module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-shadow-12.a22dfe50.png";